import type { Config } from "@wagmi/core"
import type { Address } from "viem"
import { readContract } from "@wagmi/core"

import { superVoterAbi } from "@/domains/abis"

type SuperVoterUserManagerOfProps = {
  account: Address
  chainId: number
  config: Config
  superVoterAddress: Address
}

/**
 * Read `managerOf(account)` on the SuperVoter contract, which returns the
 * address the account has delegated to (or the zero address if none).
 *
 * Returns `undefined` when the RPC call fails. Callers MUST treat the result
 * as `Address | undefined` — never cast it to `Address` because the crash
 * propagates straight into `isAddressEqual` and kills the settings page.
 */
export const superVoterUserManagerOf = async ({
  account,
  chainId,
  config,
  superVoterAddress,
}: SuperVoterUserManagerOfProps): Promise<Address | undefined> => {
  try {
    const manager = (await readContract(config, {
      account,
      abi: superVoterAbi,
      address: superVoterAddress,
      functionName: "managerOf",
      args: [account],
      chainId,
    })) as Address

    return manager
  } catch (error) {
    console.error("superVoterUserManagerOf", error)
    return undefined
  }
}
